import { FormData, AnnualRetirementTableRow, AnnualMetrics, NECRates, MBCBPRates } from '../Models/disability-calculator';
import { formatCurrencyInteger, toNumber, getYearValueOrDefault, ceil2, parseUTCDate, roundTo5Decimals } from '../utils/utils';
import { generateUnifiedAnnualTable } from '../utils/unifiedTable';

export function getAnnualRetirementTableData(formData: FormData): AnnualRetirementTableRow[] {
  const { employmentInfo } = formData;
  const currentDisabilityYear = parseUTCDate(employmentInfo.dateOfDisability).getFullYear();
  const annualUnifiedTable = generateUnifiedAnnualTable(formData);

  return annualUnifiedTable.map((yearData, index) => {
    const year = (currentDisabilityYear + index).toString();
    const annualMetricsForYear = Object.values(yearData)[0] as AnnualMetrics;

    const qual401kCatch = annualMetricsForYear.qual401kCatch;
    const totalDirectMbcbp = annualMetricsForYear.totalDirectMbcbp;
    const totalQualifiedRetirement = annualMetricsForYear.totalQualifiedRetirement;
   
    return {
      year,
      qual401kCatch: formatCurrencyInteger(qual401kCatch),
      totalDirectMbcbp: formatCurrencyInteger(totalDirectMbcbp),
      totalQualifiedRetirement: formatCurrencyInteger(totalQualifiedRetirement)
    };
  });
}